module.exports = __webpack_public_path__ + "static/media/active_donors_empty.12d789e2.svg";